<template>
    <button-bar>
        <asli-button v-if="showBack" id="form-back" color="secondary" type="button" @click="emit('back')">
            Back
        </asli-button>
        <asli-button v-if="showContinue" :disabled="isDisabled" id="form-continue" color="primary" type="submit">
            {{ continueButtonTitle }}
        </asli-button>
    </button-bar>
</template>

<script lang="ts" setup>
import { AsliButton } from "@mbs-npm/anpost-ui";
import ButtonBar from "./ButtonBar.vue";

defineProps({
    showBack: {
        type: Boolean,
        default: true
    },
    showContinue: {
        type: Boolean,
        default: true
    },
    isDisabled: {
        type: Boolean,
        default: false
    },
    continueButtonTitle: {
        type: String,
        default: "Continue"
    },
    stackButtonsOnMobile: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits<{ (e: "back"): void }>();
</script>
